/**
 * Execute in windowLoad() so the loader
 * goes away as soon as the page is loaded.
 * Remove it from the DOM after X seconds, just in case.
 */
function exitLoader(target) {
    const loaderElement = document.querySelector(target);

    if (loaderElement) {
        document.body.classList.add(`page--loaded`);

        if (window.DEBUG) {
            console.log(`Loader has been dismissed.`);
        }

        // Escape the Loader
        setTimeout(() => {
            loaderElement.remove(); 

            if (window.DEBUG) {
                console.log(`Loader has been destroyed.`);
            }
        }, 7000);
    }
}

window.addEventListener('load', () => {
	exitLoader('#siteLoader');
}); 

